import React from 'react';
import { withFormik } from 'formik';
// components
import MaintenanceTable from 'shared/tables/MaintenanceTable';
// helpers
import errorToastr from 'shared/helpers/errorToastr';
import toastr from 'shared/helpers/toastr';

const SettlementDetailsTable = ({
  initialValues,
  values,
}) => {
  return (
    <MaintenanceTable
      stickyFooter={false}
      data={values && values.settlementRunDetailEarnings || []}
      showPagination={false}
      noResultsText={'Select a PRO from the left to view details.'}
      columns={[
        { Header: 'Description', accessor: 'description' },
        { Header: 'Quantity', accessor: 'quantity', width: 75, isCentered: true },
        { Header: 'Rate', id: 'rate', accessor: 'rate', width: 55, isCentered: true },
        { Header: 'Gross Pay', accessor: 'grossPay', width: 85, isCurrency: true },
        { Header: 'Commission', accessor: 'commission', width: 95, isCurrency: true },
        { Header: 'Net Pay', accessor: 'netPay', width: 80, isCurrency: true },
        { Header: 'Pay Status', id: 'shouldPay', accessor: d => d.shouldPay ? 'PAY' : 'DO NOT PAY', width: 90, isCentered: true },
      ]}
      headerChildren={
        <div style={{ marginTop: 0, fontSize: '1rem', fontWeight: 600, color: '#016496' }}>Detail View</div>
      }
    />
  );
};

export default withFormik({
  enableReinitialize: true,
  mapPropsToValues: ({ initialValues = {} }) => {
    return {
      ...initialValues,
    };
  },
  handleSubmit: async (values, { setSubmitting, resetForm, props: { close } }) => {
    setSubmitting(true);
    try {
      console.log('values', values);
      // await save values
      close(true);
      resetForm();

      toastr('success', 'Details Saved Successfully.');
    } catch (error) {
      errorToastr({
        error,
        messagePrefix: 'Details Save Failed!'
      });
      setSubmitting(false);
    }
  }
})(SettlementDetailsTable);
